import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

const size = 50

const StButton = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  width: ${size}px;
  height: ${size}px;
  > .btn-bg {
    display: block;
    position: absolute;
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
      0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),
      0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size}px;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(98, 195, 0);
    svg {
      fill: white;
    }
  }
`

const Button = () => {
  return (
    <StButton>
      <animated.div className="btn-bg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 90.35 69.09"
          width={size - 26}
          height={size - 26}>
          <polygon points="0 37.94 9.74 25.43 35.76 46.88 78.51 0 90.35 10.62 37.41 69.09 0 37.94" />
        </svg>
      </animated.div>
    </StButton>
  )
}

export default Button
